class Sugerencia{
    constructor(Id, Titulo, Lugar, Tipo){
        this.Id=Id;
        this.Titulo=Titulo;
        this.Lugar=Lugar;
        this.Tipo=Tipo;
    }
}

export default Sugerencia;